import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=553b8f05&scoped=true"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553b8f05",
  null
  
)

export default component.exports